const checkInCircleFilledIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM17.4745 7.71491L10.3636 14.6988L6.52553 10.9292C6.23001 10.639 5.75516 10.6432 5.46491 10.9388C5.17467 11.2343 5.17895 11.7091 5.47447 11.9994L9.83811 16.2851C10.1299 16.5716 10.5974 16.5716 10.8892 16.2851L18.5255 8.78509C18.8211 8.49484 18.8253 8.01999 18.5351 7.72447C18.2448 7.42895 17.77 7.42467 17.4745 7.71491Z"
    fill="#4D8D77"
  />
</svg>
`

export default checkInCircleFilledIcon
